import React, { useState, useEffect } from "react"
import {
  Box,
  Button,
  TextField,
} from '@material-ui/core';


const Step0 = ({step, setStep, reps, setReps}) => {


  return (
    <>
      <Box sx={{
        width:"1600px",
        height:"2560px",
        backgroundColor:"background.default",
        overflow:"hidden",
      }}>
        {/* HEADER */}
        <Box sx={{ display:"flex", paddingTop:"40px", paddingLeft:"0px", gap:"0px", justifyContent:"center"}}>
          <Box sx={{
            fontSize:"85px",
            fontWeight:"bold",
            color:"white"
          }}>
            Le Search bar par
          </Box>
          <Box sx={{
            width:"520px",
            height:"117px",
            background:"url('./static/logo_blanc.png')",
            backgroundSize:"contain",
            backgroundSize:"444px 100px",
            backgroundRepeat:"no-repeat",
            backgroundPosition:"center center",
          }}>

          </Box>
          {/*<Box sx={{
            fontSize:"85px",
            fontWeight:"bold",
            color:"white"
          }}>
            Gemini
          </Box>*/}
        </Box>

        {/* CENTER */}
        <Box sx={{
          paddingTop:"200px",
          display:"flex",
          flexDirection:"column",
          gap:"120px"
        }}>
          <Box sx={{
            fontSize:"140px",
            fontWeight:"600",
            color:"white",
            textAlign:"center"
          }}>
            Trouvez votre<br/>
            <Box sx={{color:"primary.main"}}>smoothie idéal</Box>
          </Box>
          <Box sx={{
            fontSize:"45px",
            color:"#C7C5D5",
            textAlign:"center"
          }}>
            Dites-nous quelle est votre humeur du moment,<br/> et Gemini va concocter un smoothie sur mesure, parfaitement<br/>adapté à votre rythme du jour.<br/>
            Entrez votre prénom pour lancer l'expérience.
          </Box>
          <Box sx={{
            fontSize:"80px",
            fontWeight:"600",
            color:"white",
            textAlign:"center",
            marginTop:"140px",
          }}>
            Votre prénom
          </Box>
          <Box sx={{flex:1, marginTop:"-50px", display:"flex", justifyContent:"center"}}>
            <TextField
              variant="outlined"
              sx={{
                width:"90%"
              }}
              value={reps?.name}
              onChange={(e) => { setReps({...reps, name : event.target.value}) }}
              inputProps={{ maxLength: 15 }}
              onKeyPress={(e) => {
                var key = e.charCode || e.keyCode || 0;
                if (key === 13) {
                  console.log("press enter")
                  let button = document.getElementById("button_for_start")
                  if (button) {
                    button.focus()
                    button.blur()
                  }
                }
              }}
            />
          </Box>
          <Box sx={{textAlign:"center", paddingTop:"500px"}}>
            <Button
              id="button_for_start"
              variant="contained"
              disabled={reps?.name?.trim()?.length < 3}
              onClick={() => { setStep(1) } }
              sx={{
                boxShadow:reps?.name?.trim()?.length < 3 ? "" : "0px 10px 40px rgba(131, 132, 247, 0.5) !important "
              }}
            >
              Démarrer l'expérience
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Step0;
